import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ticketing-button-siguiente',
  templateUrl: './button-siguiente.component.html',
  styleUrls: ['./button-siguiente.component.scss']
})
export class ButtonSiguienteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
